/**
 * @module store/slides/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает массив всех слайдов
 *
 * @returns {array}
 */
const slides = state => state.slides;

/**
 * Getter: Возвращает флаг, загружаются ли слайды
 *
 * @returns {boolean}
 */
const isSlidesLoading = state => state.isSlidesLoading;


export default {
  slides,
  isSlidesLoading,
};
